module.exports = __webpack_public_path__ + "img/q9.6b18bfbc.png";